import { render } from "./SpeechDetailDialog.vue?vue&type=template&id=262827f0&scoped=true&ts=true"
import script from "./SpeechDetailDialog.vue?vue&type=script&lang=ts"
export * from "./SpeechDetailDialog.vue?vue&type=script&lang=ts"

import "./SpeechDetailDialog.vue?vue&type=style&index=0&id=262827f0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\eye-concat-program-list\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262827f0"]])

export default __exports__